import NavBarInCalendar from "./navBarInCalendar";
import TableCalendarContainter from "./tableCalendarContainer";

function Calendar2() {
  return (
    <div className="CONTAINER     ">
      <div className="mt-4 ">
        <NavBarInCalendar />
        <TableCalendarContainter />
      </div>
    </div>
  );
}
export default Calendar2;
